/* eslint-disable react/jsx-no-useless-fragment */
import { Flex, Box, VizFooter, Button } from '@ouster/webviz-react-components';

import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { OUSTER_ORG_ID } from 'src/utils/constants';

import SideNav from '../components/SideNav';
import NavUser from '../components/users/NavUser';
import {
  FlexColumnWithNav,
  NavFullHeightContainer,
  NavFlexRow,
} from '../containers/NavBar';
import { useStoreState, useStoreActions } from '../reducers';

const ProvisioningModeBanner = () => {
  const { setCurUserOrg } = useStoreActions((actions) => actions.user);
  const navigate = useNavigate();
  const returnToProvisioningManager = () => {
    // Set the flag synchronously so the UploaderContainer useEffect reads it
    // and will not cancel the uploads
    sessionStorage.setItem('exitFromProvisioning', 'true');

    // Navigate immediately (before the org switch unmounts this component)
    navigate('admin_dashboard/organization_hub/provisioning');

    setTimeout(() => {
      setCurUserOrg(OUSTER_ORG_ID);
      sessionStorage.setItem('orgChanged', 'true');
      sessionStorage.setItem('columnVisibilityChanged', 'true');
    }, 0);
  };
  return (
    <Flex alignItems="center" gap={2}>
      <span>Provisioning Mode Active</span>
      <Button
        borderRadius="sm"
        size="sm"
        variant="outline"
        colorScheme="yellow"
        leftIcon="logout"
        onClick={returnToProvisioningManager}
      >
        Exit to Manager
      </Button>
    </Flex>
  );
};

const DefaultLayout = () => {
  const { appUser, user, curUserOrg } = useStoreState(
    (storeState) => storeState.user
  );

  const { fetchUserOrgs } = useStoreActions((actions) => actions.user);

  useEffect(() => {
    if (user?.identity_id) {
      fetchUserOrgs(user?.identity_id);
    }
  }, [fetchUserOrgs, user?.identity_id]);

  return (
    <>
      {appUser ? (
        <>
          <FlexColumnWithNav
            navCenterEl={
              curUserOrg?.is_provisioned &&
              appUser?.email?.endsWith('@ouster.io') ? (
                <ProvisioningModeBanner />
              ) : undefined
            }
            navRightEl={
              <NavFullHeightContainer>
                <NavFlexRow gap="16px">
                  <NavUser />
                </NavFlexRow>
              </NavFullHeightContainer>
            }
          >
            <Box h="100%" display="grid" gridTemplateRows="1fr auto">
              <Flex overflow="auto">
                <Box
                  w="min-content"
                  bg="var(--ouster-colors-background-surface-subtle)"
                  borderRight="1px solid"
                  borderColor="var(--color-unify-white-30)"
                  py={4}
                  position="relative"
                >
                  <SideNav />
                </Box>
                <Box
                  flex={1}
                  height="100%"
                  overflowX="hidden"
                  bg="var(--color-gray-11)"
                >
                  <Outlet />
                </Box>
              </Flex>
              <VizFooter
                mode="none"
                borderTop="1px solid"
                borderColor="var(--color-unify-white-10)"
                py="1em"
              />
            </Box>
          </FlexColumnWithNav>
        </>
      ) : (
        <Box w="100%" h="100%" display="grid" placeContent="center">
          <CircularProgress size="50px" thickness={2} />
        </Box>
      )}
    </>
  );
};

export default DefaultLayout;
